import menu from "./menu";

export default {
    root: ({props}) => ({
        class: [
            // Flexbox and Position
            "inline-flex",
            "relative",

            // Shape
            {"rounded-md": !props.rounded},
            {"rounded-full": props.rounded},
            {"shadow-lg": props.raised},

            "[&>[data-pc-name=pcbutton]]:rounded-tr-none",
            "[&>[data-pc-name=pcbutton]]:rounded-br-none",
            "[&>[data-pc-name=pcdropdown]]:rounded-tl-none",
            "[&>[data-pc-name=pcdropdown]]:rounded-bl-none",
            "[&>[data-pc-name=pcmenu]]:min-w-full",
        ],
    }),
    pcdropdown: ({props}) => ({
        root: {
            class: ["py-2 px-2 flex items-center hover:bg-stone-600/10", {"rounded-r-full": props.rounded}],
        },
    }),
    pcbutton: (ctx) => {
        // console.log(ctx);
        return {
            root: {
                class: "px-4 py-2",
            },
            icon: {
                class: "mr-2",
            },
        };
    },
    pcmenu: menu,
};
